export const getRadientBG = (): string => {
    return `
          radial-gradient(800px circle at 20% 10%, rgba(16, 185, 129, 0.18), transparent 45%),
          radial-gradient(900px circle at 80% 30%, rgba(59, 130, 246, 0.12), transparent 40%),
          radial-gradient(700px circle at 60% 90%, rgba(16, 185, 129, 0.10), transparent 40%),
          linear-gradient(180deg, #071a2b 0%, #061423 60%, #050f1b 100%)
        `;
};
